import { newYammerPostAction } from '../components/NewMessageButton.locstring.json';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import loc from 'owa-localize';
import { lazyOpenYammerPublisher } from 'owa-yammer-publisher';

export function getYammerPublisherItemMenuOption(): IContextualMenuItem {
    if (!isFeatureEnabled('tri-newYammerPostButton')) {
        return null;
    }

    // TODO: check if post to yammer from was disabled by tenant admin
    // TODO: check if user has Yammer license
    // TODO: check if user has Yammer presence

    return {
        key: 'yammerPost',
        text: loc(newYammerPostAction),
        iconProps: { iconName: ControlIcons.YammerLogo },
        onClick: () => {
            lazyOpenYammerPublisher.importAndExecute();
        },
        onMouseOver: () => {
            // TODO: Prefetch and bootstrap yammer
            //
            //lazyBootstrapYammer.import().then(bootstrapYammer => bootstrapYammer());
            //logUsage('YammerPublisher_PrefetchHit');

            lazyOpenYammerPublisher.import();
        },
    };
}
